import { BaseResource } from 'utils/ApiUtils';

class Project extends BaseResource {
    constructor(args) {
      super(args, Project.attributes);
    };
  
    static columns = [
      { title: "Create Date", field: "DateEntered", type: "date", defaultSort: 'desc'  },
      { title: "Project Name", field: "ProjectName", width:"25%" },
      { title: "Status", field: "Description_ProjectStatus", sorting: true,width:"5%" },
      { title: "Internal Project #", field: "ProjNumber" },
      { title: "Project ID", field: "ProjectId", hidden: true },
      { title: "Organization Id", field: "OrganizationId", hidden: true },
      { title: "Assigned Resources", field: "Name_SystemUser", sorting: false, type: "string", width:"30%" },
      { title: "Assigned Resource Ids", field: "SystemUserId_SystemUser", sorting: false, hidden: true, type: "guid"},
      { title: "Type", field: "Description_ProjectType", hidden: true },
      { title: "Organization Name", field: "Name_Organization" }
    ]
  
    static expand = [{
      ResourceAssignment: {
        expand: {
          SystemUser: {
            select: ["Name", "SystemUserId"]
          }
        }
      },
      ProjectType: {
        select: ["Description"]
      },
      Organization: {
        select: ["Name"]
      },
      ProjectStatus: {
        select: ["Description"]
      }
    }];
  
    static attributes = Project.columns.map(r => r.field);
  
    static collectionFilterAttributes = [
      {
        field: "Name_SystemUser",
        buildExpand: (v) => ({
          "ResourceAssignment": {
            any: {
              "SystemUser": {
                Name: { contains: v }
              }
            }
          }
        }),
        mapToAttributes: (item) => {
          return item.resourceAssignment.map(j => j.SystemUser.Name).filter(r => r !== "System").join(", ");
        }
      },
      {
        field: "SystemUserId_SystemUser",
        buildExpand: (v) => ({
          "ResourceAssignment": {
            any: {
              "SystemUser": {
                "SystemUserId": { eq: { type: 'guid', value: v } } 
              }
            }
          }
        }),
        mapToAttributes: (item) => {
          return item.resourceAssignment.map(j => j.SystemUser.SystemUserId).join(", ");
        }
      },
    ];
  
  };

  export default Project;